<template>
	<div class="title-header">
		<div class="wrapper">
			<div style="margin-top: 5px;">
				<button	
					@click="$emit('go-to-back')">
					<img src="/static/img/left-arrow.svg" alt="">
				</button>
			</div>
			<div>
				<span
					class="text"
					:style="`color:${gray ? $appColors.info : $appColors.primary}`"
				>
					{{ title }}
				</span>
			</div>
			<slot></slot>
		</div>
	</div>
</template>
<script>
export default {
	name: 'c-title-header',
	props: {
		title: String,
		gray: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.title-header {
		.wrapper {
			align-items: center;
			// border-bottom: 1px solid color(border-gray);
			display: flex;
			justify-content: start;
			gap: 20px;
			padding: 0 5px 10px;
			.text {
				font-family: font(bold);
				font-size: size(xlarge);
			}
			&.pb-0 {
				padding-bottom: 0px;
			}
		}
	}

	.subtitle-header {
		font-family: font(regular);
		font-size: size(xlarge);
	}
</style>





// WEBPACK FOOTER //
// src/modules/job-profile/components/content/c-title-header.vue